import React, { Component } from 'react';
import { connect } from 'react-redux';
import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';
import Router from 'next/router';
// import { fromJS } from 'immutable';
import styled from 'styled-components';

import { actions as appActions } from '~/redux/reducers/app';
import { actions as tripActions } from '~/redux/reducers/trip';
import { actions as galleryActions } from '~/redux/reducers/gallery';
import { actions as popupActions } from '~/redux/reducers/popup';
import { actions as toastActions } from '~/redux/reducers/toast';
import { actions as sessionActions } from '~/redux/reducers/session';

import NoSSR from '~/components/NoSSR';
import HeadTag from '~/components/Head/HeadTag';
import Modal from '~/components/Modal/Modal';
import NotFound from '~/components/NotFound/NotFound';
import Common from '~/components/TripDetail/Common';
// import ShareSocialsModal from '~/components/TripDetail/ShareSocialsModal';
// import Gallery from '~/components/General/Gallery/Gallery';
import CustomizeTripForm from '~/components/Customize/CustomizeTripForm';
import { path } from '~/utils/media';
import { getCookie } from '~/utils/helpers';
import { parseDataToQuery, isMultiTier } from '~/utils/payment';
import Colors from '~/utils/colors';
import { forceProductPath, getProductUrl } from '~/utils/trip';
import { triggerViewSingleContent, triggerViewManyContent, triggerAddToCart } from '~/utils/data-layer';
import config from '~/config';
// import findIndex from 'lodash/findIndex';
// import cloneDeep from 'lodash/cloneDeep';
import moment from 'moment-timezone';

moment.tz.setDefault('Asia/Bangkok');

const Gallery = dynamic(() => import(/* webpackChunkName: "General.Gallery.components" */'../../components/General/Gallery/Gallery'), { ssr: false, loading: () => null });
const ShareSocialsModal = dynamic(() => import(/* webpackChunkName: "TripDetail.ShareSocialsModal.components" */'../../components/TripDetail/ShareSocialsModal'), { ssr: false });
// const NotFound = dynamic(() => import(/* webpackChunkName: "NotFound.components" */'../../components/NotFound/NotFound'));

const MainContainer = styled.div`
  box-sizing: border-box;
  margin-bottom: 24px;
`;

const TooltipHeaderContaienr = styled.div`
  padding: 8px 0 10px;
  border-bottom: 1px solid ${Colors.lineGray2};
`;

const InspirationIcon = styled.i`
  display: inline-block;
  height: 22px;
  width: 22px;
  margin-right: 5px;
  background: url('/static/icons/inspiration-or.png') no-repeat 50% 50%;
  background-size: contain;
  position: relative;
  top: 2px;
`;

const TooltipHeader = styled.h3`
  color: ${Colors.darkOrange};
  font-size: 15px;
  text-align: center;
  margin: 0;
`;

const TooltipContent = styled.p`
  font-size: 13px;
  color: ${Colors.lightGray};
  padding: 0 10px;
  @media (max-width: 700px) {
    text-align: center;
    margin-top: 0;
  }
`;

const GroupedTrips = styled.div`
  margin-bottom: 10px;
  padding: 6px 0;
`;

const GroupLabel = styled.p`
  font-size: 16px;
`;

const TierContainer = styled.div`
  padding: 10px 0;
  ${props => props.hideBottom && 'borderBottom: none'};
`;

const TierHeader = styled.div`
  padding: 10px 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  span {
    text-align: left;
  }
`;

const Radio = styled.div`
  width: 25px;
  min-width: 25px;
  height: 25px;
  min-height: 25px;
  border-radius: 50%;
  border: 1px solid ${Colors.borderGray};
  margin-right: 10px;
  background-color: ${Colors.white};
  ${props => props.active
    && `
      background-image: url('${config.assetPath}/static/icons/gray-dot.png');
      background-repeat: no-repeat;
      background-position: 50% 50%;
      background-size: 60%;
  `}
`;

const RadioLabel = styled.span`
  color: ${Colors.lightGray};
  position: relative;
  top: 4px;
  ${props => props.active && 'font-weight: 400;'}
`;

const OrangeButton = styled.a`
  user-select: none;
  padding: 7px 12px;
  border-radius: 5px;
  border: 1px solid transparent;
  display: inline-block;
  box-sizing: border-box;
  text-decoration: none;
  text-align: center;
  cursor: pointer;
  font-weight: 500;
  outline: none;
  color: ${props => props.theme.white};
  background: ${props => props.theme.orange};
`;

const enhance = connect(
  state => {
    // const forcedMapData = state.trip.data.toJS ? state.trip.data.toJS() : fromJS(state.trip.data).toJS();
    return {
      // trip: forcedMapData,
      trip: state.trip.data,
      isError: state.trip.isError,
      isRedirect: state.trip.isRedirect,
      isMobile: state.app.isMobile,
      loading: state.trip.loading,
      loaded: state.trip.loaded,
      isOpenShare: state.trip.isOpenShare,
      tab: state.trip.mobileTab,
      sessionData: state.session.data,
      rates: state.info.exchangeRates,
      siteConfigs: state.info.siteConfigs,
      isWishlisted: state.wishlist.wishlistObj.isWishlisted,
      multiTierQuantity: state.trip.multiTierQuantity,
      foreignMultiTierQuantity: state.trip.foreignMultiTierQuantity,
      activeTier: state.trip.activeTier,
      isPrefetched: state.app.isPrefetched,
      availability: state.availability,
      toasts: state.toast.toasts,
      userConfig: state.info.userConfig,
      isSessionDataLoaded: state.session.isSessionDataLoaded,
      galleryName: state.gallery.galleryName,
      isOpenLocaltableGallery: state.localTable.isOpen,
    };
  },
  {
    ...tripActions,
    openTourCategory: popupActions.openTourCategory,
    openAndGoTo: galleryActions.openAndGoTo,
    closeGallery: galleryActions.closeGallery,
    globalLoad: appActions.loading,
    // prefetchLegacySite: appActions.prefetchLegacySite,
    closeBlackFridayToast: toastActions.closeBlackFridayToast,
    addToConversionSource: sessionActions.addToConversionSource
  }
);

class TripDetail extends Component {
  static propTypes = {
    globalLoad: PropTypes.func,
    changeTier: PropTypes.func,
    changeMultiTierQuantity: PropTypes.func,
    foreignMultiTierQuantity: PropTypes.object,
    isError: PropTypes.bool,
    isOpenShare: PropTypes.bool,
    activeTier: PropTypes.string,
    trip: PropTypes.object,
    isRedirect: PropTypes.bool,
    multiTierQuantity: PropTypes.array,
    sessionData: PropTypes.object,
    loading: PropTypes.bool,
    loaded: PropTypes.bool,
    openShare: PropTypes.func,
    logRequest: PropTypes.func,
    isPrefetched: PropTypes.bool,
    // prefetchLegacySite: PropTypes.func,
    availability: PropTypes.object,
    openTourCategory: PropTypes.func,
    toasts: PropTypes.array,
    closeBlackFridayToast: PropTypes.func,
    logViewTrip: PropTypes.func,
    viewedTrip: PropTypes.func,
    customizeQty: PropTypes.func,
    isSessionDataLoaded: PropTypes.bool,
    galleryName: PropTypes.string,
    isOpenLocaltableGallery: PropTypes.bool,
    openAndGoTo: PropTypes.func,
    closeGallery: PropTypes.func
  };

  static async getInitialProps({ store, query, req, res }) {
    // let lastTripData;
    const { slug } = query;
    try {
      const data = await store.dispatch(tripActions.getTripData(encodeURI(slug)));
      // lastTripData = cloneDeep(data.data);
      const productType = data && data.data && data.data.product_type;
      let qstr = '';
      if (req && req.url && req.url.match(/\?.+/)) {
        qstr = req.url.match(/\?.+/);
      }
      if (data.data.is_redirect) {
        if (res && res.writeHead) {
          // server side
          if (!!data.data.slug) { // type switching
            res.writeHead(301, { Location: `/${productType === 'ticket' ? 'ticket' : 'trip'}/${data.data.slug}${qstr}` });
            res.end();
          } else if (!!data.data.original_slug) { // swapped trip
            res.writeHead(301, { Location: `/trip/${data.data.original_slug}${qstr}` });
            res.end();
          } else if (!!data.data.location) { // switching to city page
            res.writeHead(301, { Location: `/to/${data.data.location}${qstr}` });
            res.end();
          }
        } else {
          // client side
          if (!!data.data.original_slug) { // swapped trip
            await Router.replace(
              {
                pathname: '/trip-detail',
                query: {
                  slug: data.data.original_slug,
                  fullPath: `/trip/${data.data.original_slug}`
                },
              },
              `/trip/${data.data.original_slug}${qstr}`
            );
          }
          await Router.replace( // switching to city page
            {
              pathname: '/city',
              query: {
                city: data.data.location,
                fullPath: `/to/${data.data.location}`
              },
            },
            `/to/${data.data.location}`
          );

          if (typeof window !== 'undefined' && window && window.scrollTo) { // I think it's not necessary to check this anymore because at this scope was client side checked.
            window.scrollTo(0, 0);
          }
        }
      }

      let redirectLocation;
      // special cases that force these products to use /product/
      if (forceProductPath.includes(data.data._id.toString()) && req && req.url && !req.url.match(/^\/product\//gi)) {
        redirectLocation = `${getProductUrl(data.data)}${qstr}`;
      } else if (req && req.url && req.url.match(/^\/trip\//gi)) {
        if (productType === 'ticket') {
          redirectLocation = `/ticket/${data.data.slug}${qstr}`;
        } else if (['car_rental', 'souvenir'].includes(productType)) {
          redirectLocation = `/product/${data.data.slug}${qstr}`;
        }
      } else if (req && req.url && req.url.match(/^\/ticket\//gi)) {
        if (productType === 'trip') {
          redirectLocation = `/trip/${data.data.slug}${qstr}`;
        } else if (['car_rental', 'souvenir'].includes(productType)) {
          redirectLocation = `/product/${data.data.slug}${qstr}`;
        }
      } else if (req && req.url && req.url.match(/^\/product\//gi)) {
        if (!forceProductPath.includes(data.data._id.toString())) {
          if (productType === 'trip') {
            redirectLocation = `/trip/${data.data.slug}${qstr}`;
          } else if (productType === 'ticket') {
            redirectLocation = `/ticket/${data.data.slug}${qstr}`;
          }
        }
      }
      // if (lastTripData) {
      // store.dispatch(tripActions.syncUpTrip(lastTripData));
      // }
      if (redirectLocation) {
        res.writeHead(301, { Location: redirectLocation });
        res.end();
      }
    } catch (error) {
      if (res) res.statusCode = 404;
    }
    return {};
  }

  constructor(props) {
    super(props);
    this.onRequest = this.onRequest.bind(this);
    this.onRequestV2 = this.onRequestV2.bind(this);
    this.onOpenGroupedModal = this.onOpenGroupedModal.bind(this);
    this.onChangeTripInGroup = this.onChangeTripInGroup.bind(this);
    this.isObtainUserConfig = false;
    this.state = {
      isOpenGroupedModal: false,
      isOpenGuaranteed: false,
      isOpenCustomizeQty: false,
      customizeObj: {},
      selectedSlug: props.trip.slug,
      selectedId: props.trip._id
    };
  }

  componentDidMount() {
    this.props.logViewTrip(this.props.trip);
    this.props.viewedTrip(this.props.trip._id);
    // if (!this.props.isPrefetched) {
    //   setTimeout(() => {
    //     this.props.prefetchLegacySite();
    //   }, 5000);
    // }
    // const blackFridayToast = this.props.toasts.find(t => t.code === 'BLACKFRI17');
    // const hasBlackFridayToast = blackFridayToast ? !blackFridayToast.closed : false;
    // if (hasBlackFridayToast) {
    //   this.props.closeBlackFridayToast();
    // }
    if (isMultiTier(this.props.trip)) {
      this.props.changeTier(this.props.trip.multi_tier_prices[0].tier);
      const qty = [...this.props.multiTierQuantity];
      if (qty[0] && qty[0].sub_tiers.length > 0) {
        qty[0].sub_tiers[0].quantity = this.props.sessionData.quantity;
        const foreignQty = {...this.props.foreignMultiTierQuantity};
        Object.keys(this.props.foreignMultiTierQuantity).forEach(cur => {
          foreignQty[cur][0].sub_tiers[0].quantity = this.props.sessionData.quantity;
        });
        this.props.changeMultiTierQuantity(qty, foreignQty);
      }
    }
    const { isSessionDataLoaded } = this.props;
    if (isSessionDataLoaded) {
      this.activateConversion();
    }
    const { trip } = this.props;
    triggerViewSingleContent(trip, 'Dynamic Remarketing - View Trip Detail');
    // dataLayer().push({
    //   event: 'Dynamic Remarketing - View Trip Detail',
    //   dynamic_remarketing_trip_id: trip._id,
    //   fbads_event: 'ViewContent',

    //   gads_event: 'view_item',
    //   gads_params: [{
    //     id: trip._id,
    //     google_business_vertical: 'custom',
    //   }],
    //   dynx_itemid: trip._id,
    //   dynx_pagetype: eventMapping.view_item,
    // });

    const similarTrips = (trip.similarTrips || []).map(t => t._id);
    if (similarTrips.length > 0) {
      triggerViewManyContent(similarTrips, 'Dynamic Remarketing - Similar Trips');
      // dataLayer().push({
      //   event: 'Dynamic Remarketing - Similar Trips',
      //   dynamic_remarketing_trip_ids: similarTrips,
      //   fbads_event: 'ViewContent',
      //   gads_event: 'view_item_list',
      //   gads_params: similarTrips.map(id => ({
      //     id,
      //     google_business_vertical: 'custom',
      //   })),
      //   dynx_itemid: similarTrips,
      //   dynx_pagetype: eventMapping.view_item_list,
      // });
    }
  }

  // componentWillReceiveProps(nextProps) {
  //   if (
  //     this.props.userConfig !== nextProps.userConfig
  //     && !this.isObtainUserConfig
  //     && this.props.trip.product_type === 'trip'
  //   ) {
  //     const { trip } = nextProps;
  //     const similarTrips = (trip.similarTrips || []).map(t => t._id);
  //     if (similarTrips.length > 0) {
  //       dataLayer().push({
  //         event: 'Dynamic Remarketing - Similar Trips',
  //         dynamic_remarketing_trip_ids: similarTrips,
  //         gads_event: 'view_item_list',
  //         gads_params: similarTrips.map(id => ({
  //           id,
  //           google_business_vertical: 'custom',
  //         })),
  //         dynx_itemid: similarTrips,
  //         dynx_pagetype: eventMapping.view_item_list,
  //       });
  //     }
  //     this.isObtainUserConfig = true;
  //   }
  // }

  componentWillUpdate(nextProps) {
    if (this.props.trip._id !== nextProps.trip._id) {
      this.props.logViewTrip(nextProps.trip);
      this.activateConversion(nextProps);
    } else if (!this.props.isSessionDataLoaded && nextProps.isSessionDataLoaded) {
      this.activateConversion(nextProps);
    }
  }

  componentWillUnmount() {
    try {
      this.props.closeGallery();
    } catch (e) {
      console.log('catch error inside will unmount', e);
    }
  }

  onRequest(event, requestType, device, options) {
    const { trip, activeTier, multiTierQuantity } = this.props;
    let quantity;
    if (trip.product_type === 'souvenir' && options) {
      quantity = options.souvenirQuantity;
    } else {
      quantity = this.getQuantity();
    }
    const paymentData = {
      trip,
      quantity,
      requestType,
      device,
      options,
      step: 1,
    };
    if (options && options.customTripSlug && options.customTripId) {
      paymentData.trip.slug = options.customTripSlug;
      paymentData.trip._id = options.customTripId;
    }
    if (trip.product_type === 'souvenir' && options) {
      paymentData.deliveryLocation = options.deliveryLocation;
    }
    const { selectedDate, acceptSwap } = this.props.availability;
    if (selectedDate) {
      paymentData.date = selectedDate;
    }
    if (acceptSwap) {
      paymentData.acceptSwap = true;
    }
    if (activeTier) {
      const tier = multiTierQuantity.findIndex(t => t.tier === activeTier);
      let sum = 0;
      paymentData.tier = tier;
      paymentData.subTiers = multiTierQuantity[tier].sub_tiers.map(s => {
        sum += s.quantity || 0;
        return s.quantity || 0;
      });
      if (device !== 'mobile' && sum && selectedDate) {
        paymentData.step = 2;
      } else if (paymentData.subTiers && paymentData.subTiers.length > 0) {
        paymentData.subTiers[0] = paymentData.subTiers[0] || this.props.sessionData.quantity;
      }
    } else if (multiTierQuantity && multiTierQuantity.length > 0) {
      paymentData.tier = 0;
      paymentData.subTiers = multiTierQuantity[0].sub_tiers
        .map((s, i) => (
          i === 0 ? this.props.sessionData.quantity : 0
        ));
    }
    if (trip.product_type === 'souvenir' && device !== 'mobile' && quantity && paymentData.date) {
      paymentData.step = 2;
    }
    if (trip.product_type === 'car_rental' && device !== 'mobile' && options && options.carRental && options.carRental.from && options.carRental.to) {
      paymentData.step = 2;
    }
    const link = parseDataToQuery(paymentData);
    if (event) {
      this.props.logRequest({
        tripId: trip._id,
        quantity,
        multiTierQuantity,
        requestType,
        device,
      });
      if (trip.product_type === 'trip' && trip.trip_type === 'joined' && !getCookie('joinTourInformed')) {
        this.props.openTourCategory(true, link, '_self', trip.destination_location);
        event.preventDefault();
        event.stopPropagation();
        return false;
      }

      triggerAddToCart(trip);
      // dataLayer().push({
      //   event: 'Dynamic Remarketing - Click Book or Message',
      //   dynamic_remarketing_trip_id: trip._id,
      //   fbads_event: 'AddToCart',
      //   fbads_params: {
      //     value: ...,
      //     currency: 'THB',
      //   },
      //   gads_event: 'add_to_cart',
      //   gads_params: [{
      //     id: trip._id,
      //     google_business_vertical: 'custom',
      //   }],
      //   dynx_itemid: trip._id,
      //   dynx_pagetype: eventMapping.add_to_cart,
      // });
      // this.props.globalLoad();
    }
    return link;
  }

  onRequestV2(event, requestType, device, link, quantity) {
    const { trip, multiTierQuantity } = this.props;
    if (event) {
      this.props.logRequest({
        tripId: trip._id,
        quantity,
        multiTierQuantity,
        requestType,
        device,
      });
      if (trip.trip_type === 'joined' && !getCookie('joinTourInformed')) {
        this.props.openTourCategory(true, link, '_self', trip.destination_location);
        event.preventDefault();
        event.stopPropagation();
        return false;
      }
      // this.props.globalLoad();
    }
    return true;
  }

  onOpenGroupedModal() {
    this.setState({ isOpenGroupedModal: true });
  }

  onChangeTripInGroup(trip) {
    this.setState({ selectedSlug: trip.slug, selectedId: trip._id });
  }

  getQuantity() {
    if (this.props.trip.fixed_quantity) return this.props.trip.fixed_quantity;
    return this.props.sessionData.quantity > this.props.trip.max_travelers
      ? this.props.trip.max_travelers
      : this.props.sessionData.quantity;
  }

  activateConversion(props = this.props) {
    const { url, trip } = props;
    const source = url && url.query && url.query.conversion_source;
    if (!source) return;
    props.addToConversionSource(source, trip._id);
  }

  render() {
    const { galleryName, loading, loaded, trip, isError, isOpenShare, isRedirect, /* toasts */ } = this.props;
    const { isOpenGuaranteed, isOpenCustomizeQty, isOpenGroupedModal, selectedId, selectedSlug } = this.state;
    // const blackFridayToast = toasts.find(t => t.code === 'BLACKFRI17');
    // const hasBlackFridayToast = blackFridayToast ? !blackFridayToast.closed : false;
    if (isError) return <NotFound />;
    if (isRedirect) return <div />;

    trip.reviews = trip.reviews.map(r => {
      const review = { ...r };
      const vote = (
        this.props.sessionData.helpfulReview
        && Object.keys(this.props.sessionData.helpfulReview).find(k => k === trip._id)
        && this.props.sessionData.helpfulReview[trip._id].find(v => v.review_id === review._id)
      );
      // review.vote = vote && vote.helpful;
      if (vote && vote.helpful) {
        review.vote = vote.helpful;
      }
      return review;
    });

    return (
      <MainContainer>
        <HeadTag
          title={`${trip.title || trip.name} - TakeMeTour`}
          image={path(trip.cover_image)}
          description={trip.meta_description || trip.introduction}
          keywords={trip.keywords || [trip.destination_location, ...trip.activities].join(',')}
        />
        {/* <Helmet
          title={trip.title || trip.name}
          meta={[
            {
              'og:image': path(trip.cover_image),
              'og:description': trip.meta_description || trip.introduction,
              description: trip.meta_description || trip.introduction,
              keywords: trip.keywords || [trip.destination_location, ...trip.activities].join(',')
            }
          ]}
        /> */}
        {loaded
        && !loading && (
          <Common
            {...this.props}
            trip={{...trip}}
            onOpenGroupedModal={this.onOpenGroupedModal}
            // hasBlackFridayToast={hasBlackFridayToast}
            onRequest={this.onRequest}
            onRequestV2={this.onRequestV2}
            onChangeMultiTier={this.onChangeMultiTier}
            onChangeTier={this.onChangeTier}
            openGuaranteed={() => this.setState({ isOpenGuaranteed: true })}
            openCustomizeQty={(obj) => this.setState({ isOpenCustomizeQty: true, customizeObj: obj })}
            // multiTierQuantity={this.state.multi_tier_quantity}
            // activeTier={this.state.activeTier}
          />
        )}
        <NoSSR>
          {loaded && !!galleryName && <Gallery />}
          {loaded && isOpenShare && (
            <Modal isOpen={isOpenShare} onClose={() => this.props.openShare(false)} centerVertical style={{ maxWidth: '600px', padding: '0', margin: '0 auto' }}>
              <ShareSocialsModal slug={trip.slug}/>
            </Modal>
          )}
          {isOpenGuaranteed && (
            <Modal isOpen onClose={() => this.setState({ isOpenGuaranteed: false })} centerVertical style={{ maxWidth: '600px', padding: '0', margin: '0 auto' }}>
              <div>
                <TooltipHeaderContaienr>
                  <TooltipHeader>
                    <InspirationIcon />
                    {trip.product_type === 'ticket' && 'Best price guaranteed'}
                    {trip.product_type === 'trip' && '100% Satisfaction guaranteed'}
                  </TooltipHeader>
                </TooltipHeaderContaienr>
                <TooltipContent>
                  {trip.product_type === 'trip' && (
                    <span>Enjoy your perfect day trip with us today <br/>or get your 100% money back</span>
                  )}
                  {trip.product_type === 'ticket' && (
                    <span>
                      Find a lower price and we’ll refund the difference or DOUBLE the difference! (T&Cs apply)
                    </span>
                  )}
                </TooltipContent>
              </div>
            </Modal>
          )}
          {isOpenCustomizeQty && (
            <Modal
              isOpen
              style={{ maxWidth: '600px', padding: '0 0 10px', margin: '0 auto', textAlign: 'left' }}
              onClose={() => this.setState({ isOpenCustomizeQty: false })}
            >
              <CustomizeTripForm
                onClose={() => this.setState({ isOpenCustomizeQty: false })}
                onSubmit={(data) => {
                  this.props.customizeQty({ ...data, trip_id: trip._id });
                  this.setState({ isOpenCustomizeQty: false });
                }}
                maxTravelers={trip.max_travelers}
                customizeObj={this.state.customizeObj}
              />
            </Modal>
          )}
          {trip.grouped_trips && isOpenGroupedModal && (
            <Modal isOpen onClose={() => this.setState({ isOpenGroupedModal: false })} centerVertical zIndex={4001}>
              {trip.grouped_trips && (
                <GroupedTrips>
                  <GroupLabel>{trip.grouped_trips.label}</GroupLabel>
                  <TierContainer hideBottom>
                    {trip.grouped_trips.trip_ids.map(groupTrip => (
                      <TierHeader onClick={() => this.onChangeTripInGroup(groupTrip.trip)} >
                        <Radio active={groupTrip.trip.slug === selectedSlug} />
                        <RadioLabel active={groupTrip.trip.slug === selectedSlug}>{groupTrip.label}</RadioLabel>
                      </TierHeader>
                    ))}
                  </TierContainer>
                  <OrangeButton
                    onClick={e => this.onRequest(e, 'book', 'mobile', { customTripSlug: selectedSlug, customTripId: selectedId })}
                    href={this.onRequest(null, 'book', 'mobile', { customTripSlug: selectedSlug, customTripId: selectedId })}
                    rel="noopener noreferrer nofollow"
                  >
                    {trip.product_type === 'souvenir'
                      ? <span>Buy It Now</span>
                      : <span>Book</span>
                    }
                  </OrangeButton>
                </GroupedTrips>
              )}
            </Modal>
          )}
        </NoSSR>
      </MainContainer>
    );
  }
}

export default enhance(TripDetail);
